/* @flow */

import navigation from 'services/NavigationService';
import { apiService } from 'services/ServiceRegistry';

import Form from '../_.extend';

export const makeFields: Function = (itemData: Object, t: Function) => {
  return [
    {
      name: 'support',
      label: t('general:detail_plural'),
      fields: [
        {
          name: 'askHelpFor',
          label: t('general:labels.i_want_help'),
          rules: 'required',
          placeholder: '',
          value: itemData ? itemData.id : null,
          extra: {
            selectID: itemData ? itemData.id : null,
            parentId: null,
            actionButton: false,
          },
        },
        {
          name: 'comments',
          label: t('general:labels.comments'),
          rules: 'required',
          multiline: true,
          value: null,
        },
      ],
    },
  ];
};

class SupportFormCreate extends Form {}

export const supportCreate: Function = (fields: Array<*>, localState: Object, props: Object) => {
  const t: Function = props.t;
  const locationState: Object = props.location && props.location.state;

  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const { askHelpFor, comments }: Object = form.values().support;

      const jsonObj: Object = {
        help_with: askHelpFor,
        comments,
      };

      apiService
        .putResource('contact-support', jsonObj)
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              locationState && locationState.redirectTo
                ? navigation.navigateTo(`/${locationState.redirectTo}`)
                : navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_error');
          localState.hasSuccess = false;
          localState.hasError = true;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.form_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
    },
  };

  return new SupportFormCreate({ fields }, { hooks, name: t('general:support_request') });
};
